import React, { useState } from 'react';
import './Login.css';
import { Link, useHistory } from 'react-router-dom';
import { auth, provider } from './firebase';

function Login() {
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const signIn = (e) => {
    e.preventDefault();

    auth
      .signInWithEmailAndPassword(email, password)
      .then((auth) => {
        history.push('/');
      })
      .catch((error) => alert(error.message));
  };

  const register = (e) => {
    e.preventDefault();

    auth
      .createUserWithEmailAndPassword(email, password)
      .then((auth) => {
        if (auth) {
          history.push('/');
        }
      })
      .catch((error) => alert(error.message));
  };

  const google = async (e) => {
    e.preventDefault();
    await auth
      .signInWithPopup(provider)
      .then((auth) => {
        history.push('/');
      })
      .catch((error) => alert(error.credentrial));
  };

  return (
    <div className='login'>
      <Link to='/'>
        <img
          className='login__logo'
          src='https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/1024px-Amazon_logo.svg.png'
        />
      </Link>

      <div className='login__container'>
        <h1>Sign-In</h1>

        <form>
          <h5>E-mail</h5>
          <input
            type='text'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <h5>Password</h5>
          <input
            type='password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button className='login__signInButton'> Sign In </button>
          <button className='login__signInButton' onClick={google}>
            <img
              src='https://premiumitsolutions.com.au/wp-content/uploads/2015/10/google-logo-2015-google-beta.jpg'
              style={{ width: 8 + '%' }}
              alt=''
            />
            Sign up with Google
          </button>
        </form>
        <p>
          By signing-in you agree to this Amazon Fake Clone Terms of Use &
          Sales. Please see our Privacy Notice, our Cookies Notice and our
          Interest-Based Ads Notice.
        </p>

        <button onClick={register} className='login__registerButtton'>
          Create your Amazon Account
        </button>
      </div>
    </div>
  );
}

export default Login;
